'use client';

import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Button } from './Button.js';

export interface ErrorStateProps {
  title?: string;
  description?: string;
  icon?: ReactNode;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({
  title = 'Something went wrong',
  description = 'An error occurred while loading the data. Please try again.',
  icon,
  onRetry,
  retryLabel = 'Try Again',
}: ErrorStateProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        padding: 4,
        textAlign: 'center',
      }}
    >
      <Box sx={{ mb: 2, color: 'error.main' }}>
        {icon ?? <ErrorOutlineIcon sx={{ fontSize: 64 }} />}
      </Box>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
        {description}
      </Typography>
      {onRetry && (
        <Button variant="contained" onClick={onRetry}>
          {retryLabel}
        </Button>
      )}
    </Box>
  );
}
